import { createBrowserRouter } from "react-router-dom";
import { lazy, Suspense } from "react";
import MainLayout from "../layout/MainLayout";
import Loader from "../components/Loader";
import PrivateRoute from "./PrivateRoute";

const Home = lazy(() => import("../pages/Home"));
const About = lazy(() => import("../pages/About"));
const Contact = lazy(() => import("../pages/Contact"));
const Course = lazy(() => import("../pages/Course"));
const CourseDetails = lazy(() => import("../pages/CourseDetails"));
const Privacy = lazy(() => import("../pages/Privacy"));
const Terms = lazy(() => import("../pages/Terms"));
const Refund = lazy(() => import("../pages/Refund"));
const Shipping = lazy(() => import("../pages/Shipping"));
const Login = lazy(() => import("../pages/Login"));
const Register = lazy(() => import("../pages/Register"));

const Profile = lazy(() => import("../pages/student/Profile"));
const ChangePassword = lazy(() => import("../pages/student/ChangePassword"));
const Payment = lazy(() => import("../pages/student/Payment"));
const Booking = lazy(() => import("../pages/student/Booking"));

const router = createBrowserRouter([
  {
    element: (
      <Suspense fallback={<Loader />}>
        <MainLayout />
      </Suspense>
    ),
    children: [
      { path: "/", element: <Home /> },
      { path: "/about", element: <About /> },
      { path: "/contact", element: <Contact /> },
      { path: "/course", element: <Course /> },
      { path: "/courseDetails", element: <CourseDetails /> },
      { path: "/privacy", element: <Privacy /> },
      { path: "/refund", element: <Refund /> },
      { path: "/terms", element: <Terms /> },
      { path: "/shipping", element: <Shipping /> },
      { path: "/login", element: <Login /> },
      { path: "/register", element: <Register /> },
      // Protected Routes for Logged-in Users
      {
        element: <PrivateRoute />,
        children: [
          { path: "/profile", element: <Profile /> },
          { path: "/booking", element: <Booking /> },
          { path: "/enrollCourse", element: <Payment /> },
          { path: "/changePassword", element: <ChangePassword /> },
        ],
      },
    ],
  },
]);

export default router;
